




































// Vue
import { Component, Vue } from 'vue-property-decorator'

// components
import HorizontalTopbar from '@/components/horizontal-topbar.vue'
import HorizontalNav from '@/components/horizontal-navbar.vue'
import Footer from '@/components/footer.vue'

// utils
import { loading } from '@/utils'

@Component({
  name: 'HorizontalLayout',
  components: {
    HorizontalTopbar,
    HorizontalNav,
    Footer
  }
})
export default class HorizontalLayout extends Vue {
  created () {
    document.body.setAttribute('data-layout', 'horizontal')
    document.body.setAttribute('data-topbar', 'dark')
    document.body.removeAttribute('data-sidebar')
    document.body.removeAttribute('data-layout-size')
  }

  mounted () {
    document.body.classList.remove('auth-body-bg')
    if (this.layoutOptions.loader === true) {
      loading('show')
      setTimeout(function () {
        loading('hide')
      }, 2500)
    } else {
      loading('hide')
    }
  }

  // Methods
  toggleRightSidebar () {
    document.body.classList.toggle('right-bar-enabled')
  }

  hideRightSidebar () {
    document.body.classList.remove('right-bar-enabled')
  }

  // computed
  get layoutOptions () {
    return {
      ...this.$store.state.layout
    }
  }
}
